export default {
  submitButton: {
    id: 'in_store_checkout_addresses_step_submit_button',
    defaultMessage: 'Next',
  },
  editButton: {
    id: 'in_store_checkout_addresses_step_edit_button',
    defaultMessage: 'Edit shipping address',
  },
}
